import Pagination from './pagination.element.js';

export default Pagination;

Pagination.define('wje-pagination', Pagination);
